module.exports = __webpack_public_path__ + "img/student-resource-active.30991fc7.svg";